import React, { ReactNode } from 'react';
import { Technology } from '../../../backend/models/technology';
import { Person } from '../../../backend/models/person';
import { Client } from '../../../backend/models/client';

export function getLogoUrl(name: string) {
  return `/api/logos/${name}`;
}

export function createTechnologyTableData(technology: Technology, persons: Person[]) {
  const table: { label: string; value: ReactNode }[] = [];
  const partnerManagerId = technology.personRelations?.find((p) => p.relationType === 'partnerManager')?.personId;
  const partnerManager = partnerManagerId ? persons.find((p) => p.id === partnerManagerId) : undefined;
  if (partnerManager) {
    table.push({ label: 'Partner manager:', value: <span>{partnerManager.name}</span> });
  }

  const techLeadId = technology.personRelations?.find((p) => p.relationType === 'techLead')?.personId;
  const techLead = techLeadId ? persons.find((p) => p.id === techLeadId) : undefined;
  if (techLead) {
    table.push({ label: 'Tech lead:', value: <span>{techLead.name}</span> });
  }

  const superUserIds = technology.personRelations
    ?.filter((p) => p.relationType === 'superUser')
    ?.map((p) => p.personId);
  const superUsers = superUserIds ? persons.filter((p) => superUserIds.includes(p.id)) : undefined;
  if (superUsers && superUsers.length > 0) {
    table.push({
      label: 'Super user(s):',
      value: (
        <>
          {superUsers.map((u) => (
            <span key={u.id}>{u.name}</span>
          ))}
        </>
      ),
    });
  }
  if (technology.contractLink) {
    table.push({
      label: 'Contract link:',
      value: (
        <a href={technology.contractLink} target="_blank" rel="noreferrer">
          {technology.contractLink}
        </a>
      ),
    });
  }
  return table;
}

export function createClientTableData(client: Client, persons: Person[]) {
  const table: { label: string; value: ReactNode }[] = [];

  const solutionArchitectIds = client.personRelations
    ?.filter((p) => p.relationType === 'solutionArchitect')
    ?.map((p) => p.personId);
  const solutionArchitects = solutionArchitectIds
    ? persons.filter((p) => solutionArchitectIds.includes(p.id))
    : undefined;
  if (solutionArchitects && solutionArchitects.length > 0) {
    table.push({
      label: 'Solution architect(s):',
      value: (
        <>
          {solutionArchitects.map((u) => (
            <span key={u.id}>{u.name}</span>
          ))}
        </>
      ),
    });
  }
  return table;
}
